export default "__VITE_ASSET__ggqmICDg__"